// extracted by mini-css-extract-plugin
export default {"SoonPageContainer":"SoonPage_SoonPageContainer__-sTRv","SoonPageLoading":"SoonPage_SoonPageLoading__RSL71"};